import { render, staticRenderFns } from "./CreaSondaggio.vue?vue&type=template&id=7cf42f76&scoped=true&slot=tag&slot-scope=props&"
import script from "./CreaSondaggio.vue?vue&type=script&lang=js&"
export * from "./CreaSondaggio.vue?vue&type=script&lang=js&"
import style0 from "./CreaSondaggio.vue?vue&type=style&index=0&id=7cf42f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf42f76",
  null
  
)

export default component.exports